import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
  useRef,
} from "react";
import styled from "styled-components";
import { OptionType } from "./DropDown";
import { TransparentOverlay } from "./RangeModal";
import { SearchContainer, SearchImg, SearchInput } from "./Search";

interface SearchDropdownProps {
  searchValue: string | undefined;
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  placeholder: string;
  isDisabled?: boolean;
  keywordList?: OptionType[];
  saveLabel?: boolean;
}

export default function SearchDropdown({
  placeholder,
  searchValue,
  setSearchValue,
  isDisabled,
  keywordList,
  saveLabel,
}: SearchDropdownProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const [isMouseOvered, setIsMouseOvered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [openAutoComplete, setOpenAutoComplete] = useState(true);
  const [value, setValue] = useState("");
  const [autoCompleteList, setAutoCompleteList] = useState<OptionType[]>([]);
  console.log("❤️", value);
  console.log(searchValue);

  console.log("isFocused", isFocused, "openAutoComplete", openAutoComplete);

  useEffect(() => {
    if (autoCompleteList && autoCompleteList?.length > 0) {
      setOpenAutoComplete(true);
    } else {
      setOpenAutoComplete(false);
    }
  }, [autoCompleteList]);

  useEffect(() => {
    if (keywordList) {
      setAutoCompleteList(keywordList);
    }
  }, [keywordList]);

  return (
    <SearchDropdownContainer>
      <SearchContainer>
        <SearchInput
          type="text"
          placeholder={placeholder}
          value={value}
          disabled={isDisabled}
          isDisabled={isDisabled}
          onFocus={() => setIsFocused(true)}
          onClick={() => setOpenAutoComplete(true)}
          onChange={(e) => {
            setValue(e.target.value);

            const filtered = keywordList?.filter((a) =>
              a.label?.includes(e.target.value)
            );

            console.log(filtered);

            if (filtered) {
              setAutoCompleteList(filtered);
            }
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              const filtered = keywordList?.filter((a) =>
                a.label?.includes(value)
              );

              if (filtered?.length === 1) {
                setSearchValue(
                  saveLabel ? `${filtered[0]?.label}` : `${filtered[0]?.value}`
                );
              } else {
                setSearchValue(value);
              }
              setIsFocused(false);
            }
          }}
        />

        <SearchImg
          isFocused={isFocused}
          isDisabled={isDisabled}
          onClick={() => {
            const filtered = keywordList?.filter((a) =>
              a.label?.includes(value)
            );

            if (filtered?.length === 1) {
              setSearchValue(
                saveLabel ? `${filtered[0]?.label}` : `${filtered[0]?.value}`
              );
            } else {
              setSearchValue(value);
            }
            setIsFocused(false);
          }}
        >
          <span className="material-icons-outlined">search</span>
        </SearchImg>
      </SearchContainer>

      {isFocused && (
        <>
          <AutoCompleteContainer
            onMouseOver={() => setIsMouseOvered(true)}
            ref={modalRef}
          >
            {autoCompleteList?.map((k) => (
              <AutoCompleteItem
                key={k?.value}
                onClick={() => {
                  console.log("⭐");
                  setOpenAutoComplete(false);

                  setValue(`${k?.label}`);
                  setSearchValue(saveLabel ? `${k.label}` : `${k?.value}`);
                  setIsFocused(false);
                }}
              >
                {k?.label}
              </AutoCompleteItem>
            ))}
          </AutoCompleteContainer>

          <TransparentOverlay onClick={() => setIsFocused(false)} />
        </>
      )}
    </SearchDropdownContainer>
  );
}

const SearchDropdownContainer = styled.div`
  position: relative;
`;

const AutoCompleteContainer = styled.div`
  position: absolute;
  z-index: 3;
  width: 240px;
  max-height: 300px;
  background-color: #ffffff;
  border: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  overflow-y: scroll;
`;

const AutoCompleteItem = styled.div`
  cursor: pointer;
  min-height: 38px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 16px;

  font-size: 14px;
  text-align: left;
  color: #505050;

  &:hover {
    background-color: #f5f5f5;
  }
`;
